<mat-toolbar class="app-toolbar">
  <mat-icon aria-hidden="true">receipt_long</mat-icon>
  <div class="app-heading">
    <h1 class="app-title">Flanders</h1>
    <p class="app-subtitle">Outil d'observabilité des factures envoyées vers Flowie</p>
  </div>
  @if (info(); as i) {
    <span
      class="env"
      [class.env-prod]="i.flowieEnvironment === 'PROD'"
      [attr.aria-label]="'Environnement ' + i.flowieEnvironment"
    >
      {{ i.flowieEnvironment }}
    </span>
  }
  <span class="spacer"></span>
  @if (me.me(); as user) {
    <span class="user">
      <mat-icon aria-hidden="true">{{ user.isAdmin ? 'admin_panel_settings' : 'person' }}</mat-icon>
      {{ user.displayName || user.userPrincipalName }}
    </span>
    @if (!auth.isDevelopment) {
      <button
        mat-icon-button
        (click)="logout()"
        matTooltip="Se déconnecter"
        aria-label="Se déconnecter"
      >
        <mat-icon>logout</mat-icon>
      </button>
    }
  }
  @if (info(); as i) {
    <span class="version">v{{ i.version }}</span>
  } @else {
    <span class="version">API indisponible</span>
  }
</mat-toolbar>

@if (auth.isDevelopment) {
  @if (info()?.flowieEnvironment === 'PROD') {
    <div class="dev-banner prod" role="alert">
      <mat-icon aria-hidden="true">gpp_bad</mat-icon>
      <strong>DONNÉES DE PRODUCTION sans authentification</strong> — consultation réservée à ce
      poste (dérogation AUTH_DEV_ALLOW_PROD). Ne pas partager l'adresse de cette page.
    </div>
  } @else {
    <div class="dev-banner" role="alert">
      <mat-icon aria-hidden="true">warning</mat-icon>
      Mode développement : authentification désactivée, toute personne accédant à cette page est
      administrateur.
    </div>
  }
}

@if (showAlertBanner()) {
  <div class="alert-banner" role="status">
    <mat-icon aria-hidden="true">notifications_active</mat-icon>
    <span> {{ alerts.summary()!.unread }} alerte(s) non lue(s) — {{ bannerDetail() }} </span>
    <a routerLink="/alertes" [queryParams]="{ unreadOnly: true }">Voir les alertes</a>
    <span class="spacer"></span>
    <button mat-icon-button (click)="dismissBanner()" aria-label="Masquer le bandeau">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

<mat-sidenav-container class="app-container">
  <mat-sidenav mode="side" opened class="app-nav">
    <mat-nav-list>
      <a
        mat-list-item
        routerLink="/"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon>dashboard</mat-icon><span matListItemTitle>Tableau de bord</span>
      </a>
      <a mat-list-item routerLink="/documents" routerLinkActive="active">
        <mat-icon matListItemIcon>description</mat-icon><span matListItemTitle>Documents</span>
      </a>
      <a mat-list-item routerLink="/annuaire" routerLinkActive="active">
        <mat-icon matListItemIcon>menu_book</mat-icon><span matListItemTitle>Annuaire</span>
      </a>
      <a mat-list-item routerLink="/alertes" routerLinkActive="active">
        <mat-icon matListItemIcon>notifications</mat-icon>
        <span matListItemTitle>
          Alertes
          @if (alerts.summary()?.unread) {
            <span class="badge" [attr.aria-label]="alerts.summary()!.unread + ' non lues'">{{
              alerts.summary()!.unread
            }}</span>
          }
        </span>
      </a>
      @if (me.isAdmin()) {
        <a mat-list-item routerLink="/supervision" routerLinkActive="active">
          <mat-icon matListItemIcon>sync</mat-icon><span matListItemTitle>Supervision</span>
        </a>
        <a mat-list-item routerLink="/administration" routerLinkActive="active">
          <mat-icon matListItemIcon>settings</mat-icon><span matListItemTitle>Administration</span>
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <main class="app-content">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
